import { InjectionToken } from '@angular/core';

export const AUTH_URL = new InjectionToken<string>('AUTH_URL');

export const UNAUTHORIZED_URL = new InjectionToken<string | undefined>(
  'UNAUTHORIZED_URL'
);
